export default __webpack_public_path__ + "static/media/education.c4c958cd.svg";